import { OutlineCard } from '@morressier/alembic';
import { FormFieldSelect as IFormFieldSelect } from '@publishing-engine/domain/types/article';
import FormFieldSelect from 'src/components/FormField/FormFieldSelect';

const SubjectArea = ({ config }: { config: IFormFieldSelect }) => (
  <OutlineCard borderless padding={8}>
    <FormFieldSelect config={config} />
  </OutlineCard>
);

export default SubjectArea;
